import React,{PureComponent} from 'react'
import {Switch,Route, Redirect} from 'react-router-dom';

import CancelRecord from "@pages/CancelRecord/index";
import CancelRecordDetails from "@pages/CancelRecord/Details/index";
import CancelRecordAddNew from "@pages/CancelRecord/AddNew/index";

// 客户取消记录 管理
class CancelRecordRouter extends PureComponent{
    render() {
        return (
            <Switch>
                <Route path="/cancelRecord/index" component={CancelRecord} />
                <Route path="/cancelRecord/details" component={CancelRecordDetails} />
                <Route path="/cancelRecord/addNew" component={CancelRecordAddNew} />
                <Route path="/*" render={(props) => <Redirect to="/cancelRecord/index" />} />
            </Switch>
        );
    }
}
export default CancelRecordRouter;